import { render, staticRenderFns } from "./PvBtn.vue?vue&type=template&id=0439d29e&scoped=true&"
import script from "./PvBtn.vue?vue&type=script&lang=js&"
export * from "./PvBtn.vue?vue&type=script&lang=js&"
import style0 from "./PvBtn.vue?vue&type=style&index=0&id=0439d29e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0439d29e",
  null
  
)

export default component.exports